import React, { FC } from 'react';
import { SubtenantList } from './list/SubtenantList';

export const SubtenantsPage: FC = React.memo(function SubtenantsPage() {
  return <SubtenantList />;
});
